// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"533":"5aa1fded","934":"e9d834a4"}[chunkId] + ".chunk.css";
};